/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import * as React from 'react';
import MethodCard from './MethodCard';
import './MethodGrid.scss';
import paramConfig from '../../../modules/calculator/parameterConfig_NEW.json';
import { isMobileOnly } from 'react-device-detect';

interface Method {
  id: number;
  heading: string;
  subHeading: string;
  longDesc: string;
}

interface MethodGridProps {
  theme: string;
  activeMethod: number;
  onMethodSelect: (method: number) => void;
}

const MethodGrid = ({ theme, activeMethod, onMethodSelect }: MethodGridProps) => {
  return (
    <div className={`method-grid ${activeMethod > -1 ? '' : 'method-grid--active'} ${isMobileOnly ? 'method-grid--mobile' : 'method-grid--desktop'}`}>
      {paramConfig.methods.map((method: Method) => {
        return (
          <MethodCard
            key={method?.id}
            method={method?.id}
            activeMethod={activeMethod}
            onMethodSelect={onMethodSelect}
            theme={theme}
            heading={method?.heading}
            subHeading={method?.subHeading}
            longDesc={method?.longDesc}
          />
        );
      })}
      {isMobileOnly && <div className="method-grid__item" />}
    </div>
  );
};

export default MethodGrid;
